var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIndividual2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#1855f1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M29.4,25H26.9V8.15a.662.662,0,0,0-.65-.65h-5a4.375,4.375,0,1,0-8.75,0H11.4a2.972,2.972,0,0,0,.45-1.6V3.1A3.115,3.115,0,0,0,8.75,0H3.1A3.115,3.115,0,0,0,0,3.1V5.9A3.115,3.115,0,0,0,3.1,9h.05V25H.65a.662.662,0,0,0-.65.65v.9A3.457,3.457,0,0,0,3.45,30h23.1A3.457,3.457,0,0,0,30,26.55v-.9a.655.655,0,0,0-.6-.65M16.9,4.4a3.169,3.169,0,0,1,3.15,3.15,3.117,3.117,0,0,1-4.1,2.95A3.061,3.061,0,0,1,13.8,7.55,3.064,3.064,0,0,1,16.9,4.4M11.25,17.5a5.625,5.625,0,1,1,11.25,0V20H11.25ZM1.25,5.9V3.1A1.846,1.846,0,0,1,3.1,1.25H8.8A1.846,1.846,0,0,1,10.65,3.1V5.9A1.819,1.819,0,0,1,9.5,7.6a1.883,1.883,0,0,1-.95.15.594.594,0,0,0-.6.5l-.2,1L6.1,7.85a.568.568,0,0,0-.4-.15H3.1A1.774,1.774,0,0,1,1.25,5.9M4.4,9H5.45c2.4,2,2.3,1.95,2.4,2a.589.589,0,0,0,.5.051.688.688,0,0,0,.4-.5L9.05,9A3.245,3.245,0,0,0,10,8.8h2.7a4.505,4.505,0,0,0,1.7,2.35,11.217,11.217,0,0,0-1.1.55A6.955,6.955,0,0,0,10.05,17c-.05.5,0,.6,0,3.7a.662.662,0,0,0,.65.65H23.2a.661.661,0,0,0,.65-.65,38.652,38.652,0,0,0-.05-3.9,6.955,6.955,0,0,0-4.35-5.65,4.322,4.322,0,0,0,1.7-2.35H25.7V25H4.4ZM28.75,26.55a2.22,2.22,0,0,1-2.2,2.2H3.45a2.22,2.22,0,0,1-2.2-2.2v-.3h27.5Z",
    transform: "translate(0 0)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndividual2);
export default __webpack_public_path__ + "static/media/Icon-individual-2.80091bbe5cb30b4fc7e5e4d39886522f.svg";
export { ForwardRef as ReactComponent };